import main from './main.vue'
const commonImagePicker = {
  install: (Vue) => Vue.component(main.name, main)
}

export default commonImagePicker